export default "__VITE_ASSET__BWi1GsuG__"